import styled from "styled-components";
import { colours } from "../../styles/colours.constants";

export const IconButton = styled.button`
	background: ${colours.red};
	border-radius: 999px;
	width: 45px;
	height: 40px;
	border: none;
	display: flex;
	justify-content: center;
	align-items: center;
	align-self: flex-start;

	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}
`;
